<template>
  <layout-full class="d-flex justify-content-center align-items-center">
    <router-view />
  </layout-full>
</template>

<script>
import LayoutFull from '@core/layouts/layout-full/LayoutFull.vue'

export default {
  components: {
    LayoutFull,
  },
}
</script>

<style scoped>

</style>
